<template>
  <header class="client-display">
    <figure v-if="displayLogo && client.logo">
      <img :src="client.logo.small" :alt="`${client.title} logo`" />
    </figure>

    <h2>{{ client.title }}</h2>
  </header>
</template>

<script lang="ts" setup>
import type { ScenarioClient } from '/@front:types/shared'

withDefaults(
  defineProps<{
    client: ScenarioClient
    displayLogo?: boolean
  }>(),
  {
    displayLogo: true,
  },
)
</script>
